import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './component/css/app1.css';
import reportWebVitals from './reportWebVitals';

import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider
} from 'react-router-dom';

import { HelmetProvider } from "react-helmet-async";  // ✅ Add this

import Layout from './Layout';
import Home from './component/Home/Home';
import About from './component/Home/About';
import Services from './component/Home/Services';
import ErrorPage from './component/Error-Handler/ErrorPage';
import SEO_Services from './component/Home/SEO_Services';
import Website_Services from './component/Home/Website_Services';
import UI_UX from './component/Home/UI_UX';
import Ads_Management from './component/Home/Ads_Management';
import Graphic_Design from './component/Home/Graphic_Design';
import Social_Media from './component/Home/Social_Media';
import Content_Writing from './component/Home/Content_Writing';
import Stratergy_Positioning from './component/Home/Stratergy_Positioning';
import InnerPage from './component/Home/InnerPage';
import ContactUs from './component/Home/ContactUs';
import Blogs from './component/Home/Blog';
import BlogMay from './component/Home/component/Bloginner/BlogMay';
import PrivacyPolicy from './component/Home/Privacypolicy';

const basePath = '';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={`${basePath}`} element={<Layout />} errorElement={<ErrorPage />}>
      <Route index element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="services/seo" element={<SEO_Services />} />
      <Route path="services/website-development" element={<Website_Services />} />
      <Route path="services/ui-ux" element={<UI_UX />} />
      <Route path="services/ads-management" element={<Ads_Management />} />
      <Route path="services/graphic-design" element={<Graphic_Design />} />
      <Route path="services/social-media" element={<Social_Media />} />
      <Route path="services/content-writing" element={<Content_Writing />} />
      <Route path="services/stratergy-positioning" element={<Stratergy_Positioning />} />
      <Route path="/inner-page" element={<InnerPage />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blog1" element={<BlogMay />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>   {/* ✅ Wrap RouterProvider */}
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
